import instance from "api/cmsapi";

const DEFAULT_ASSESSMENT_LEVEL = "EmVZbr0kApz";

export async function getActiveAssessmentUsers() {
  const response = await instance.get("assessment-users/active");
  const users = Array.isArray(response?.data) ? response.data : [];

  return users
    .map((user) => ({
      username: String(user?.username || user?.userName || "").trim(),
      level: String(
        user?.level
        || user?.districtId
        || user?.organisationUnitId
        || user?.orgUnitId
        || user?.locationId
        || "",
      ).trim() || DEFAULT_ASSESSMENT_LEVEL,
    }))
    .filter((user) => user.username);
}
